import styled from 'styled-components'
// import media from 'styled-media-query'

export const SearchForm = styled.form`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  height: 48px;

  /* Overlay effect */
  position: inherit;
  background-color: #fff;
  z-index: 1000

  /* Interaction/Blend/01 */
  background: rgba(22, 22, 22, 0.04);
  box-shadow: inset 0px -1px 0px #4B4B4B;
  border-radius: 4px 4px 0px 0px;

  /* Inside Auto Layout */
  flex: none;
  order: 0;

  flex-grow: 1;
  margin: 0px 0px;
`

export const SearchFormOld = styled.form`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${props => props.theme.colors.white};

  @media only screen and (max-width: 767px) {
    border-bottom: 1px solid ${props => props.theme.colors.white};
  }
`

export const SearchStaticIcon = styled.div`
  display: block;
  margin: 0 1.6rem;
  width: 3rem;

  @media only screen and (max-width: 767px) {
    display: block;
  }
`

export const SearchInput = styled.input`
  grid-area: inputSearch;
  display: block;
  width: 100%;
  background-color: transparent;
  border: none;
  color: ${props => props.theme.showcase.textResultSearch};
  font-family: ${props => props.theme.font};
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, 150% or 24px */
  outline: none;
  padding: 0;

  @media only screen and (max-width: 767px) {
    display: block;
    font-size: 1.4rem;
  }

  ::-webkit-input-placeholder {
    color: ${props => props.theme.showcase.textResultSearch};
  }
  :-moz-placeholder {
    color: ${props => props.theme.showcase.textResultSearch};
  }
  ::-moz-placeholder {
    color: ${props => props.theme.showcase.textResultSearch};
  }
  :-ms-input-placeholder {
    color: ${props => props.theme.showcase.textResultSearch};
  }
`
